<template>
  <div
    class="fixed-head"
    :class="{small, xsmall, xlarge, 'screen-sm': $vuetify.breakpoint.mdAndDown}"
  >
    <div class="head-item prefix">
      <router-link
        v-if="showBack"
        :to="backRoutePath"
      >
        <naj-button text>
          <v-icon>mdi-chevron-right</v-icon>{{ backText }}
        </naj-button>
      </router-link>
    </div>
    <div :class="[{ 'mr-4': !showBack }, 'head-item full']">
      <div class="head-row">
        <div class="head-col">
          <h1 class="page-title">
            {{ title }}
          </h1>
        </div>
        <div class="head-col" />
      </div>

      <slot />

      <div class="head-row">
        <div class="head-col" />
        <div class="head-col">
          <slot name="corner" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageHead',
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    xsmall: {
      type: Boolean,
      default: false,
    },
    xlarge: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    backText: {
      type: String,
      default: 'إلغاء',
    },
    backRoutePath: {
      type: String,
      default: '/',
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/partials/_mixins.scss';
.fixed-head {
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // height: 170px;
  background-color: #fbfbfb;
  // z-index: 100;
  padding: 10px;
  padding-top: 20px;
  box-sizing: border-box;
  display: flex;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  // &.small {
  // height: 150px;
  // }

  // &.xsmall {
  // height: 90px;
  // }

  // &.xlarge {
  // height: 320px;
  // }

  .head-item.full {
    flex: 1;
  }

  .head-item.prefix {
    margin-left: 10px;
  }

  .page-title {
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 10px;
  }

  @include md-down {
    .page-title {
      font-size: 18px;
      margin-bottom: 6px;
      line-height: 1.3;
    }
  }

  .head-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  // &.screen-sm {
  // position: static;
  // height: auto;
  // }
}
</style>
